import { Trash2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgTrash = mkIcon(Trash2);